import React from "react"
import {ConnectionStatus, ConnectionStatusDisplay} from "../../types/connection"

export const useConnectionStatusDisplay = (
	connectionStatus: ConnectionStatus | undefined,
): ConnectionStatusDisplay => {
	const status = connectionStatus?.status || "unknown"

	switch (status) {
		case "connected":
			return {
				text: connectionStatus?.displayText || "Connected",
				className:
					"bg-green-100 dark:bg-green-900/40 text-green-800 dark:text-green-300 border-green-200 dark:border-green-700",
				icon: <div className="w-2 h-2 bg-green-500 rounded-full" />,
			}
		case "disconnected":
			return {
				text: connectionStatus?.displayText || "Disconnected",
				className:
					"bg-red-100 dark:bg-red-900/40 text-red-800 dark:text-red-300 border-red-200 dark:border-red-700",
				icon: <div className="w-2 h-2 bg-red-500 rounded-full" />,
			}
		default:
			return {
				text: connectionStatus?.displayText || "Unknown",
				className:
					"bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-300 border-gray-200 dark:border-gray-600",
				icon: <div className="w-2 h-2 bg-gray-500 rounded-full" />,
			}
	}
}
